module.exports = __webpack_public_path__ + "img/msi_X.8a9aa4fc.svg";